<template>
	<div class="obras-cadastro-dialog">
		<Dialog class="test-box" :header="headerDialog" :visible.sync="showRemoverObra" :modal="true" :closable="false">
			<div class="container">
				<div class="row">
					<div class="col-md-12 mb-2 mensagem-cancelamento">
						<p>
							{{
								"A obra" +
								" " +
								(this.obras ? this.obras.detail : "") +
								" será removida."
							}}
						</p>
						<p>
							{{ "Deseja continuar?" }}
						</p>
					</div>
				</div>
			</div>

			<hr />

			<div class="botoes-avancar-voltar">
				<Button @click="removerObra()" href="#topo" type="button" label="Remover"
					class="p-button-primary mr-2 p-button-success" icon="pi pi-check" :disabled="loading" />

				<Button @click="showRemoverObra = false" type="button" label="Fechar"
					class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" />
			</div>
		</Dialog>
		<Dialog class="obras-modal" :visible.sync="showCadastroObra" :modal="true" :closable="false">
			<h1 class="titulo-header">
				{{ headerDialog }}
				<Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
					@click="showCadastroTomador = false" />
			</h1>
			<div id="topo" class="scrolable-dialog">
				<error-list :erros="erros" />
				<div class="card-body">
					<form name="form" @submit.prevent="onSubmit">
						<div class="row d-flex align-items-end">
							

							<div class="col-md-2 mb-2">
								<label>Número CNO/CEI: </label>
								<span class="p-fluid">
									<InputText type="text" maxlength="30" v-model="obras.numeroCei"></InputText>
								</span>
							</div>

							<div class="col-md-2 mb-2">
								<label>Código CIB: </label>
								<span class="p-fluid">
									<InputText type="text" v-model="obras.codigoCib" maxlength="8"></InputText>
								</span>
							</div>

							<div class="col-md-2 mb-2">
								<label>Número Alvará: </label>
								<span class="p-fluid">
									<InputText type="text" maxlength="30" v-model="obras.numeroAlvara"></InputText>
								</span>
							</div>

							<div class="col-md-2 mb-2">
								<label>Inscrição Imobiliária: </label>
								<span class="p-fluid">
									<InputText type="text" maxlength="30" v-model="obras.inscImobiliaria"></InputText>
								</span>
							</div>


						</div>
						<div class="row">
							<div class="col-md-8 mb-2">
								<label for="nome">Nome/Descritivo Obra: *</label>
								<span class="p-fluid">
									<InputText type="text" id="nome" v-model="obras.nome" />
								</span>
							</div>
						</div>
						<div class="row">
							<div class="col-md-3 mb-2">
								<label for="cep">CEP: *</label>
								<span class="p-fluid">
									<div class="p-inputgroup">
										<InputMask v-model="obras.cep" mask="99.999-999" placeholder="Pesquisar" />
									</div>
								</span>
							</div>
						</div>
						<div class="row">
							<div class="col-md-10 mb-2">
								<label for="enderecoObra">Endereço Obra: *</label>
								<span class="p-fluid">
									<textarea id="enderecoObra" name="enderecoObra" v-model="obras.enderecoObra"
										rows="5" maxlength="255" />
								</span>
							</div>
						</div>
						<div class="row">
							<div class="col-md-2 mb-2">
								<label>Número: *</label>
								<span class="p-fluid">
									<InputText type="text" maxlength="60" v-model="obras.numero"></InputText>
								</span>
							</div>
							<div class="col-md-2 mb-2">
								<label>Bairro: *</label>
								<span class="p-fluid">
									<InputText type="text" maxlength="60" v-model="obras.bairro"></InputText>
								</span>
							</div>
							<div class="col-md-2 mb-2">
								<label>Complemento: </label>
								<span class="p-fluid">
									<InputText type="text" maxlength="150" v-model="obras.complemento"></InputText>
								</span>
							</div>
						</div>

						<hr />
						<div class="botoes-avancar-voltar">
							<Button @click="salvar()" href="#topo" type="button" label="Gravar"
								class="p-button-primary mr-2 p-button-success" icon="pi pi-check" :disabled="loading" />
							<Button @click="showCadastroObra = false" type="button" label="Fechar"
								class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" />
						</div>
					</form>
				</div>
			</div>
		</Dialog>
	</div>
</template>

<script>
import money from "../conf/config.money";
import LoginService from "../services/acesso/login.service";
import obrasService from '../services/obras/obras.service';
import Obras from '../models/obras/Obras';

export default {
	name: 'ObrasCadastroDialog',
	data() {
		return {
			erros: [],
			modoEdicao: false,
			showCadastroObra: false,
			showRemoverObra: false,
			loading: false,
			money: money,
			filtro: "",
			filteredTipoObra: null,
			selectedTipoObra: null,
			filteredTipoDesconto: null,
			selectedTipoDesconto: null,
			obras: new Obras(),
		}
	},
	created() {
		this.$root.$on("notaFiscal:novaObra", () => {
			this.limparForm();
			this.modoEdicao = false;
			this.showCadastroObra = true;
			this.showRemoverObra = false;
		});
		this.$root.$on("notaFiscal:editarObra", () => {
			this.obras = this.$parent.selectedObra;
			this.modoEdicao = true;
			this.showCadastroObra = true;
			this.showRemoverObra = false;
		});
		this.$root.$on("notaFiscal:removerObra", () => {
			this.obras = this.$parent.selectedObra;
			this.showCadastroObra = false;
			this.showRemoverObra = true;
		});

		this.currentUser = LoginService.currentUserValue;

	},

	methods: {

		salvar() {
			this.processando(true);
			this.obras.idCliente = this.currentUser.usuario.idCliente;
			this.obras.idContribuinteCadastro = this.currentUser.contribuinte.idContribuinte;

			obrasService.saveObras(this.obras).then(
				data => {
					console.log(data);
					this.$toast.add({
						severity: "success",
						summary: "Obra salva com sucesso!"
					});
				},
				(error) => {
					const erros = error.response.data;
					this.erros.push(...erros);

					if (!this.erros.length) {
						this.$root.$emit(
							"alert:error",
							"Houve um problema ao salvar a Obra!"
						);
					}
				}
			);
			this.processando(false);
		},
		removerObra() {
			if (this.obras && this.obras.id) {
				this.$parent.processando(true);
				obrasService.removeObras(this.obras.id).then(
					data => {
						console.log(data);
						this.$toast.add({
							severity: "success",
							summary: "Obra removida com sucesso"
						});
					},
					error => {
						let errorMessage = "Houve um problema ao remover a Obra!";
						if (error.response) {
							errorMessage = error.response.data;
						}
						this.$toast.add({
							severity: "error",
							summary: errorMessage
						});
					}
				).then(() => {

					this.$parent.selectedObra = null;
					this.showRemoverObra = false;
					this.$parent.processando(false);
				});

			}
		},

		limparForm() {
			this.erros = [];
			this.obras.id = null;
			this.obras.saldoDisponivel = 0;
			this.obras.saldoDeduzido = 0;
			this.obras.codigoCib = '';
			this.obras.numeroCei = '';
			this.obras.numeroArt = '';
			this.obras.numeroAlvara = '';
			this.obras.nome = '';
			this.obras.dataInicio = '';
			this.obras.dataTermino = '';
			this.obras.enderecoObra = '';
			this.obras.cep = '';
			this.obras.numero = '';
			this.obras.complemento = '';
			this.obras.bairro = '';
			this.obras.inscImobiliaria = '';
			this.selectedTipoObra = null;
			this.selectedTipoDesconto = null;
			this.obras.descricao = '';
		},

		processando(show) {
			if (show) {
				this.loading = true;
				this.$root.$emit("loading:show");
			} else {
				this.loading = false;
				this.$root.$emit("loading:hide");
			}
		},

	}, computed: {
		headerDialog() {
			return (
				(this.modoEdicao
					? "Edição de "
					: "Cadastro de ") +
				"Obra"
			);
		}
	}
}
</script>

<style scoped>
.scrolable-dialog {
	padding-right: 25px;
	width: 90vw;
	max-height: 65vh;
	overflow-y: auto;
	overflow-x: hidden;
}

.p-inputtext:disabled {
	color: #a6a6a6;
	border-color: #a6a6a6;
}

textarea {
	width: 100%;
	border-radius: 12px;
}
</style>